module.exports = __webpack_public_path__ + "assets/group-2.c8daa23fd4374c31bdb442e6f656a265.png";